<template>
  <div id="works">
      <v-card
        flat
      >
        <v-row style="justify-items:center;align-items:center;">
          <v-col style="justify-content:center;" class="d-none d-xs-flex d-sm-flex" cols="1">
            <v-btn
              text
              height="80vh"
              width="80%"
              class="padding:-10px;"
              @click="prev"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="10">
          <v-window
            class="elevation-0"
            flat
            :continuous=true
            v-model="onboarding"
          >
            <v-window-item
              v-for="(item,i) in items"
              :key="i"
              :index="i"
              style="justify-content:center;margin:0 auto;"
            >
            <v-row>
              <v-col cols="12" sm="12" md="7" lg="7">
                <Loading v-show="item.loading"></Loading>
                <v-img
                  v-show="!item.loading"
                  max-height="75vh"
                  :src="item.src"
                  contain
                ></v-img>
              </v-col>
              <v-col cols="12" sm="12" md="5" lg="5" no-gatter style="align-self:center;justify-content:center;">
                <v-row>
                  <v-col style="justify-content:center;" cols="2" class="d-flex d-xs-none d-sm-none">
                    <v-btn text x-small height="100%" @click="prev">
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col
                    style="justify-content:center"
                    sm="12"
                  >
                    <v-card-title style="justify-content:center">
                      {{ item.title }}
                    </v-card-title>
                    <v-card-text class="text--primary">
                      <div style="text-align:center">{{ item.year }}</div>
                      <div style="text-align:center">{{ item.size }}</div>
                      <div style="text-align:center;color:#999;">{{ item.price }}</div>
                    </v-card-text>
                  </v-col>
                  <v-col style="justify-content:center;" cols="2" class="d-flex d-xs-none d-sm-none">
                    <v-btn text x-small height="100%" @click="next">
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            </v-window-item>
          </v-window>
          </v-col>
          <v-col style="justify-content:center;" class="d-none d-xs-flex d-sm-flex" cols="1">
            <v-btn
              text
              height="80vh"
              @click="next"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>

          </v-col>
        </v-row>
      </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading'
export default {
  data () {
    return {
      items: [
        {
          src: 'img/us.jpg',
          title: 'us',
          year: '2020',
          size: '180mm x 140mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/dream_yousmileimelt.jpg',
          title: 'Dream -You smile, I melt-',
          year: '2020',
          size: '200mm x 200mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/nanulak.jpg',
          title: 'NANULAK',
          year: '2020',
          size: '200mm x 200mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/dream_sunnysideup.jpg',
          title: 'Dream -sunny side up-',
          year: '2020',
          size: '200mm x 200mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/overflow.jpg',
          title: 'overflow',
          year: '2020',
          size: '220mm x 273mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/1752020.jpg',
          title: '17.5.2020',
          year: '2020',
          size: 'A4',
          loading: true,
          price: ''
        },
        {
          src: 'img/fall.jpg',
          title: 'fall',
          year: '2020',
          size: '200mm x 200mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/flowerandbutterfly.jpg',
          title: 'flower and butterfly',
          year: '2020',
          size: '300mm x 240mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/presentiment.jpg',
          title: 'presentiment',
          year: '2020',
          size: '140mm x 180mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/feelingofloss.jpg',
          title: 'feeling of loss',
          year: '2020',
          size: '140mm x 180mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/leave.jpg',
          title: 'leave',
          year: '2020',
          size: '140mm x 180mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/cloudy.png',
          title: 'cloudy',
          year: '2020',
          size: '410mm x 260mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/nightmare2.jpg',
          title: 'nightmare no.1',
          year: '2019',
          size: '240mm x 300mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/nightmare1.jpg',
          title: 'nightmare no.2',
          year: '2019',
          size: '240mm x 300mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/silence.jpg',
          title: 'silence',
          year: '2020',
          size: '240mm x 330mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/theonlywitness.jpg',
          title: 'the only witness',
          year: '2020',
          size: '220mm x 273mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/dearme.jpg',
          title: 'dear me',
          year: '2015',
          size: '190mm x 130mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/no_title.jpg',
          title: 'no title',
          year: '2015',
          size: '500mm x 650mm',
          loading: true,
          price: ''
        },
        {
          src: 'img/catmutilation.jpg',
          title: 'catmutilation',
          year: '2020',
          size: '530mm x 455mm',
          loading: true,
          price: ''
        },
      ],
      onboarding: 0,
    }
  },
  components: {
    Loading,
  },
  methods: {
    next () {
      this.onboarding = this.onboarding + 1 >= this.items.length
        ? 0
        : this.onboarding + 1
    },
    prev () {
      this.onboarding = this.onboarding - 1 < 0
        ? this.items.length - 1
        : this.onboarding - 1
    },
  },
  mounted () {
    this.items.map((item) => {
      axios.get(item.src)
        .then(() => {
          item.loading = false
          // console.log(item.src)
        })
    })
    setTimeout(() => {
      this.items.map((item) => {
        item.loading = false
      })
    }, 10000)
  },
}
</script>

<style scoped>
#works {
  width:90%;
  max-height:"calc( 100vh - 131px )";
  margin:0px auto;
}
.v-overlay .active {
  backdrop-filter: blur(10px);
}
@media (min-width: 600px) {
}
</style>
